import { Icon } from '@mui/material';
import { Avatar, Flex } from 'antd';
import { FunctionComponent, useEffect, useState } from 'react';

import { getPreviewAssignation } from '../../shared/api/assignationRequest';
import { isAssign, isEpLu, isEpUnlock } from '../../shared/api/serieRequest';
import { useAuth } from '../../shared/context/TokenContext';
import { Episode } from '../../shared/types/Episode';
import { Serie } from '../../shared/types/Serie';

import '../css/EpisodeRow.css';

interface EpisodeRowProps {
  episode: Episode;
  isAssigned: boolean;
  serie: Serie;
  seasonNumber: number;
  assign: (episode: Episode) => void;
  onClick: (episode: Episode, idSerie: number) => void;
}

const EpisodeRow: FunctionComponent<EpisodeRowProps> = (props: EpisodeRowProps) => {
  const { episode, isAssigned, serie, seasonNumber, assign, onClick } = props;

  const { idClasse, isEdifice, isTeacher } = useAuth();

  const [assignements, setAssignements] = useState([]);
  const [count, setCount] = useState(0);
  const [ep, setEp] = useState(episode);

  useEffect(() => {
    const loadInfos = async () => {
      const [resEpLu, resEpUnlock, resAssign, classe] = await Promise.all([
        isEpLu(`${episode.id}`),
        isEpUnlock(`${episode.id}`),
        isAssign(`${episode.id}`),
        idClasse ? getPreviewAssignation(episode.id, idClasse) : null,
      ]);

      const newEp = { ...episode };

      if (resEpLu) newEp.EpLus = resEpLu.epLu ? [resEpLu.epLu] : [];
      if (resEpUnlock) newEp.EpUnlockeds = resEpUnlock.epUnlocked ? [resEpUnlock.epUnlocked] : undefined;
      if (resAssign) newEp.isAssign = resAssign.assigned;

      setEp(newEp);

      if (idClasse && classe && classe.students.length > 0) {
        setAssignements(classe.students);
        setCount(classe.count);
      }
    };
    loadInfos();
  }, [episode, idClasse, isAssigned]);

  const getEpState = () => {
    if (!ep.EpLus || ep.EpLus.length <= 0) return 'play';

    const epLus = ep.EpLus[0];
    const finished = epLus.finished;

    if (finished !== null && finished !== undefined) {
      if (finished === true) return 'finished';

      return 'pause';
    }
    return 'play';
  };

  const getIconEp = () => {
    const state = getEpState();
    switch (state) {
      case 'pause':
        return 'pause';
      case 'finished':
        return 'done';
      case 'play':
      default:
        return 'play_arrow';
    }
  };

  const getButtonStyle = () => {
    const state = getEpState();
    switch (state) {
      case 'pause':
        return {
          background: '#ffd23f',
          border: '3px rgba(242, 185, 0, 1) solid',
        };
      case 'finished':
        return {
          background: 'green',
          border: '3px green solid',
        };
      case 'play':
      default:
        return {
          backgroundColor: '#FF6501',
          border: '3px solid #B14E0E',
        };
    }
  };

  return (
    <Flex gap={30} className="episode-row-main-flex">
      <div
        style={{ cursor: 'pointer' }}
        onClick={() => {
          onClick(ep, serie.id);
        }}>
        <Flex gap={8} style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
          <div className="episode-name" style={{ color: '#120D35', marginBottom: 8 }}>
            {`EP${ep.number} - ${ep.name}`}
          </div>
          {ep.isAssign ? (
            <Flex
              style={{
                flexDirection: 'row',
                gap: 8,
                fontSize: 12,
                padding: 10,
                backgroundColor: '#3E276F',
                borderRadius: 100,
                color: '#FFF',
                fontFamily: 'Poppins-Regular',
                wordWrap: 'break-word',
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
              }}>
              <Icon sx={{ fontSize: 14, color: 'white' }}>{'notifications'}</Icon>
              Lecture demandée
            </Flex>
          ) : null}
        </Flex>
        <div id="containerEpRow">
          <div id="imgContainerEpRow">
            <img
              style={{
                objectFit: 'contain',
                aspectRatio: 750 / 300,
                width: '100%',
                minWidth: 150,
              }}
              src={`https://newbrand.s3.eu-west-3.amazonaws.com/series/${serie.uid}/season-${seasonNumber + 1}/ep-${
                ep.number
              }/img/${ep.img}`}
              alt=""
            />
          </div>
          <div
            style={{
              flex: 1,
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex',
            }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 50,
                height: 50,
                borderRadius: 100,
                ...getButtonStyle(),
              }}>
              <Icon sx={{ fontSize: 40, color: 'white' }}>{getIconEp()}</Icon>
            </div>
          </div>
        </div>
      </div>
      {isEdifice && isTeacher && isEdifice() && isTeacher() ? (
        <Flex className="episode-row-assign-flex" justify="center" align="center" vertical gap={12}>
          {assignements.length > 0 ? (
            <Flex>
              <Avatar.Group>
                {assignements.map((a, i) => {
                  return (
                    <Avatar
                      key={i}
                      style={{
                        ...(i % 2 === 0
                          ? {
                              backgroundColor: '#FFD8BF',
                              color: '#FA541C',
                            }
                          : {
                              backgroundColor: '#FF7A45',
                            }),
                        fontSize: 16,
                        fontFamily: 'Roboto',
                        wordWrap: 'break-word',
                      }}>
                      {a}
                    </Avatar>
                  );
                })}
                {count > 0 ? (
                  <Avatar
                    key={1000}
                    style={{
                      backgroundColor: assignements.length % 2 === 0 ? '#FFD8BF' : '#FF7A45',
                      color: assignements.length % 2 === 0 ? '#FA541C' : 'white',
                      fontSize: 16,
                      fontFamily: 'Roboto',
                      wordWrap: 'break-word',
                    }}>
                    +{count}
                  </Avatar>
                ) : null}
              </Avatar.Group>
            </Flex>
          ) : null}

          <Flex
            className="episode-row-assign-btn"
            onClick={e => {
              e.stopPropagation();
              e.preventDefault();
              assign(ep);
            }}
            style={{
              background: '#FFD8BF',
              borderRadius: 8,
              border: '3px #FF6501 solid',
              padding: 8,
              cursor: 'pointer',
            }}
            justify="center"
            align="center"
            gap={10}>
            <Icon sx={{ color: '#FF6501', fontSize: 30 }}>add_box_outlined_icon</Icon>
            <div
              className="resume"
              style={{
                color: '#FF6501',
                fontSize: 14,
              }}>
              Assigner l’épisode
            </div>
          </Flex>
        </Flex>
      ) : null}
    </Flex>
  );
};

export default EpisodeRow;
